<jw-modal id='orderMaterialUpliftModal'>
  <h1 class='header'>Add Material Uplift</h1>

  <div class='form-group'>
    @if (this.isError) {
      <div class="alert alert-danger">Please complete all required fields</div>
    }
    @if (this.isServerError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    <div class='col-md-4'>
      <label>Customer</label>
      <ng-select [(ngModel)]="this.materialUplift.accountId" (change)='this.materialUplift.accountId= +$event; setAccount();'>
        @for (item of this.tips; track item) {
          <ng-option [value]='item.id'>{{ item.name }}</ng-option>
        }
      </ng-select>
    </div>
    <div class='form-row col-md-4'>
      <label>Name</label>
      <input class='form-control' type='text' [(ngModel)]="this.materialUplift.name" [class.is-invalid]='!this.materialUplift.name'/>
    </div>
    <div class='form-row col-md-4'>
      <label>Unit</label>
      <select class='form-control' (change)='this.materialUplift.unitId = +$event.target.value;setUnit();'>
        <option value='-1'>Select a unit</option>
        @for (unit of this.units; track unit) {
          <option [selected]='unit.id === this.materialUplift.unitId' [value]='unit.id'>{{ unit.name }}</option>
        }
      </select>
    </div>
    <div class='form-row col-md-4'>
      <label>Price</label>
      <input class='form-control' type='text' [(ngModel)]="this.materialUplift.price"/>
    </div>
    <div class='form-row col-md-4'>
      <label>Qty</label>
      <input class='form-control' type='number' [(ngModel)]="this.materialUplift.qty"/>
    </div>

  </div>
  <button type="submit" class="btn btn-success" (click)='this.onSubmit()'>Save</button>&nbsp;
  <button type="button" class="btn btn-danger" (click)='this.cancel()'>Cancel</button>
</jw-modal>
